export function deploymentYaml() {
  return `ProfileId: <profile-id>
WorkerImage: <newest-hexasync-worker-image>
# e.g:
#  - 001-projects/variux/bakes
#  - 001-projects/variux/maileg-eu/wholesale
#  - 001-projects/variux/maileg-us/wholesale
ProfileTemplatePath: "001-projects/<partner>/<client>/<project>"
WorkerEnv:
  - KEY=value
  - KEY=value
  - KEY=value
  - KEY=value
`;
}
